module.exports = __webpack_public_path__ + "media/images/avatar/25-2833528a259e658608b566eed0eb0823.svg";